import * as React from "react";
import { StyleProp, ViewStyle } from "react-native";
import { useTheme } from "react-native-paper";
import Svg, { Path, Rect } from "react-native-svg";
const LeftIcon = (props: { style?: StyleProp<ViewStyle> }) => {
  const { colors } = useTheme();
  return (
    <Svg width="18" height="18" viewBox="0 0 99 102" fill="none">
      <Path
        d="M5.26497 51.0957L98.9824 51.0957"
        stroke="white"
        strokeWidth="10"
        strokeMiterlimit="10"
        strokeLinejoin="round"
      />
      <Path
        d="M52.1238 97.957L5.26506 51.0983L52.1238 4.23958"
        stroke="white"
        strokeWidth="10"
        strokeLinejoin="round"
      />
    </Svg>
  );
};
export default LeftIcon;
